import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import IndentModal from "../components/indentModal";
import VehicleModal from "../components/indentVehicle";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

const AddIndentNote = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentVehicleIndex, setCurrentVehicleIndex] = useState(null);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [indent, setIndent] = useState('');
  const [formData, setFormData] = useState({});
  const [dept, setDept] = useState([]);
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////
            const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
              const permsLoaded = !!rawPerms;
              
              //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canEntry = hasPermission("Store Requisition", "entry");
              const canVehicle = hasPermission("Hire Vehicle Registration", "entry");
              /////////////////////////////////////////////////////////////
    

  useEffect(() => {
    {canEntry && (
    fetchBillNo()
    )}
  }, [branch]);

  const fetchBillNo = async () => {
    try {
      Swal.fire({
        title: "Fetching Indent Number",
        html: `
          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
          </div>
          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Indent Number...</p>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const style = document.createElement("style");
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        },
      });
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_indentNo?branch_code=${branch}`);
      if (response.data.indentNo) {
        const indentNo = parseInt(response.data.indentNo, 10) || 0;
        setIndent(indentNo.toString());
        setFormData(prevState => ({ ...prevState, newIndentNo: indentNo.toString() }));
      }
      Swal.close();
    } catch (error) {
      Swal.close();
        console.error("Error fetching Indent No. Please try again:", error);
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Error fetching Indent No. Please try again",
        });
    }
  };

  useEffect(() => {
    const fetchDept = async () => {
      if (!branch) return;
      try {
        Swal.fire({
          title: "Fetching Department",
          html: `
            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
            </div>
            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Departments...</p>
          `,
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            const style = document.createElement("style");
            style.innerHTML = `
              @keyframes progressBar {
                0% { width: 0% }
                50% { width: 100% }
                100% { width: 0% }
              }
            `;
            document.head.appendChild(style);
          },
        });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_department?branch_code=${branch}`);
        setDept(response.data.dept || []);
        Swal.close();
      } catch (error) {
        Swal.close();
        console.error("Error fetching Departments. Please try again:", error);
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Error fetching Departments. Please try again",
        });
      }
    };
    {canEntry && (
    fetchDept()
    )}
  }, [branch]);

  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [...prevItems, { ...item, vcode: "", vnumber: "", qty: "", duedate: "" }]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleVehicleSelect = (vehicle_code, vehicle_number) => {
    if (!vehicle_code || !vehicle_number) {
      console.error("Vehicle selection error: Missing vehicle_code or vehicle_number");
      return;
    }
  
    // console.log("Selected Vehicle:", vehicle_code, vehicle_number);
    
    if (currentVehicleIndex !== null) {
      setSelectedItems((prevItems) => {
        const updatedItems = prevItems.map((item, i) =>
          i === currentVehicleIndex ? { ...item, vcode: vehicle_code, vnumber: vehicle_number } : item
        );
        console.log("Updated Items:", updatedItems);
        return updatedItems;
      });
    }
  
    setCurrentVehicleIndex(null);
    setShowVehicleModal(false);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  // department check
  if (!formData.supp || formData.supp.trim() === "") {
    Swal.fire("Error", "Please select a department", "error");
    return;
  }

  // at least one item check
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // item-level validations
  for (let item of selectedItems) {
    // quantity check
    if (!item.qty || isNaN(item.qty) || Number(item.qty) <= 0) {
      Swal.fire("Error", `Enter a valid positive quantity for item: ${item.itemmaster_name}`, "error");
      return;
    }

    // due date check
    if (!item.duedate) {
      Swal.fire("Error", `Enter due date for item: ${item.itemmaster_name}`, "error");
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0); // reset time for comparison
    const dueDate = new Date(item.duedate);

    if (dueDate < today) {
      Swal.fire("Error", `Due date must be today or a future date for item: ${item.itemmaster_name}`, "error");
      return;
    }
  }

  const payload = {
    branch: branch,
    user: userId,
    indentNumber: formData.newIndentNo,
    dept: formData.supp,
    remarks: formData.remarks,
    items: selectedItems.map((item) => ({
      itemmaster_code: item.itemmaster_code,
      itemmaster_name: item.itemmaster_name,
      itemmaster_uom: item.itemmaster_uom,
      qty: item.qty,
      duedate: item.duedate,
      vcode: item.vcode,
      vname: item.vnumber,
    })),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await axios.post("https://rfs2.infraconsoft.net.in/api/store_req_detail_insert", payload);

    Swal.fire("Success", "Indent Note added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/indentNoteView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
          <h2 className="add-txt">Stores Requisition Note - Add</h2>
          <Link to='/inventory/indentNoteView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

       

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Indent No :</label>
                <input type="text" name="indentNo" value={formData.newIndentNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Department :</label>
                <select name="supp" value={formData.supp} onChange={handleChange}>
                  <option value="">-- Select Department --</option>
                  {dept.map((item, index) => (
                    <option key={index} value={item.departmentmaster_code}>
                      {item.departmentmaster_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Supervisor Code :</label>
                <input type="text" name="user" value={userId} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>



          <div className="flex_buttons">
          <button type="button" className="button button-add" onClick={() => setShowModal(true)}>Add Item</button>
        </div>
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    {canVehicle && (
                      <>
                    <th>Vehicle Code</th>
                    <th>Vehicle Number</th>
                    </>
                    )}
                    <th>Qty</th>
                    <th>Due Date</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_uom}</td>
                        {canVehicle && (
                          <>
                        <td><input type="text" value={item.vcode} readOnly onClick={() => {setCurrentVehicleIndex(index); setShowVehicleModal(true); }} placeholder="Select Vehicle" /></td>
                        <td><input type="text" value={item.vnumber} readOnly/></td> 
                        </>
                        )}
                        <td><input type="number" value={item.qty} onChange={(e) => handleRowChange(index, "qty", e.target.value)} /></td>
                        <td><input type="date" value={item.duedate} onChange={(e) => handleRowChange(index, "duedate", e.target.value)} /></td>
                        <td className="del"><i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>

          </form>
        </div>
      </div>
      <IndentModal showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} />
      <VehicleModal showModal={showVehicleModal} closeModal={() => setShowVehicleModal(false)} onSelectVehicle={handleVehicleSelect} branch={branch} rowIndex={currentVehicleIndex} />

    </div>
  );
};

export default AddIndentNote;